import { Chip } from '@forgeglobal/design-framework'
import { arraysEqual } from 'util/EnumUtils'
import { calculateDuration } from 'util/DateUtils'
import React from 'react'
import moment from 'moment'
import numeral from 'numeral'

export const createStatusChip = (campaignStatus: string) => {
  switch (campaignStatus) {
    case 'Expired':
      return <Chip label="Closed" />
    case 'Live':
      return <Chip label="Active" color="secondary" />
    case 'Draft':
      return <Chip label="Draft" />
    case 'Upcoming':
      return <Chip label="Scheduled" color="primary" />
    default:
      return null
  }
}

export const createTemporalNoteFieldText = (
  campaignStatus: string | undefined,
  availableTo: string,
  availableFrom: string
) => {
  switch (campaignStatus) {
    case 'Expired':
      return `Closed at ${moment(availableTo).format('h:mma, MMMM Do YYYY')}`
    case 'Live':
      return `${calculateDuration(new Date().toISOString(), availableTo)} remaining`
    case 'Draft':
      return `Scheduled to start at ${moment(availableFrom).format('h:mma, MMMM Do YYYY')}`
    case 'Upcoming':
      return `Scheduled to start at ${moment(availableFrom).format('h:mma, MMMM Do YYYY')}`
    default:
      return `ERROR: Campaign status ${campaignStatus} is unhandled`
  }
}

export const createAllocationBarCaption = (minDollarsToClose: number, allocatedDollars: number) => {
  const isAboveMiniumCap = minDollarsToClose ? allocatedDollars > minDollarsToClose : true

  return isAboveMiniumCap
    ? 'Minimum met to close'
    : `${numeral(minDollarsToClose - allocatedDollars)
        .format('($0.00a)')
        .toUpperCase()} remaining to meet minimum`
}

export const formatStructures = (structures: string[], options: { label: string; value: any[] }[]) => {
  const option = options.find(opt => arraysEqual(opt.value, structures))
  return option && option.label
}

export const convertToCurrencyString = (money: number) => {
  return numeral(money)
    .format('($0.00a)')
    .toUpperCase()
}
